<template>
  <div
    class="plugin-icon-box"
    :style="{
      backgroundColor: iconBgColor,
      width: $vw(size),
      height: $vw(size),
      borderRadius: $vw(iconBorderRadius)
    }"
  >
    <van-icon
      class="plugin-icon"
      :size="$vw(iconSize)"
      class-prefix="icon"
      :color="iconColor"
      :name="icon"
    />
  </div>
</template>

<script>
export default {
  name: 'ViaPluginIcon',
  props: {
    // rpx
    size: {
      type: Number,
      default: 60
    },
    icon: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: '#fff'
    },
    iconBgColor: {
      type: String,
      default: 'var(--light40)'
    }
  },
  computed: {
    iconSize() {
      return this.size / 1.5
    },
    iconBorderRadius() {
      // const radius = this.size / 4
      // return radius > 15 ? 15 : radius
      return this.size / 4
    }
  }
}
</script>

<style scoped>
.plugin-icon-box {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.plugin-icon-box::before {
  content: '';
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1));
}
</style>
